import * as React from 'react';

import Application from './Application.js';

export const AppContext = React.createContext();

const application = new Application();
application.load();

export const useApplication = () => {
	const app = React.useContext(AppContext);
	const [, forceUpdate] = React.useReducer(x => x + 1, 0);

	// This will force a re-render when the application data changes
	React.useEffect(() => {
		app.handleDataChange = () => {
			console.log('Subscriber called for component'); // Add this for debugging
			forceUpdate();
		};

	}, [app, forceUpdate]);

	return app;
};

export const AppContextProvider = React.memo(({ children, router }) => {
	const app = React.useRef(application).current;

	React.useEffect(() => {
		const hashHandler = () => {
			const path = window.location.hash.substring(1); //remove hash

			// Google H5 vignette ads temporarily use this hash while their overlay is
			// open. It is not an application route, so leave the current screen alone.
			if (path === 'google_vignette') {
				return;
			}

			app.navigate(path);
		};

		app.onNavigate = (path) => {
			window.location.hash = path;
			router.navigate('/' + path);
		};

		window.addEventListener('hashchange', hashHandler);
		window.location.hash = ''; //init hash
		router.navigate('/' + app.pageId);

		return () => {
			window.removeEventListener('hashchange', hashHandler);
		};
	}, [app, router]);

	return (
		<AppContext.Provider value={app}>
			{children}
		</AppContext.Provider>
	);
});

AppContextProvider.displayName = 'AppContextProvider';
